(() => {
  "use strict";
  const TPQ2_VERSION = "2.1.0";

  // =============================
  // COLECȚII (ca înainte)
  // =============================
  const COLLECTIONS = {
    all: "/collections/toate-produsele",
    reduceri: "/collections/reduceri",

    // DAMĂ
    pantofi_casual_dama: "/collections/pantofi-casual-dama",
    pantofi_sport_dama: "/collections/pantofi-sport-dama",
    pantofi_eleganti_dama: "/collections/pantofi-eleganti-dama",
    ghete_casual_dama: "/collections/ghete-casual-dama",
    ghete_sport_dama: "/collections/ghete-sport-dama",
    ghete_elegante_dama: "/collections/ghete-elegante-dama",
    sandale_dama: "/collections/sandale-dama",

    // BĂRBAȚI (diacritice -> le codăm când facem link)
    pantofi_casual_barbati: "/collections/pantofi-casual-barbati",
    pantofi_sport_barbati: "/collections/pantofi-sport-barbati",
    pantofi_eleganti_barbati: "/collections/pantofi-eleganti-barbati",
    ghete_casual_barbati: "/collections/ghete-casual-barbati",
    ghete_sport_barbati: "/collections/ghete-sport-barbați",
    ghete_elegante_barbati: "/collections/ghete-elegante-barbati",
    sandale_barbati: "/collections/sandale-barbați",

    // COPII
    pantofi_casual_copii: "/collections/pantofi-casual-copii",
    pantofi_sport_copii: "/collections/pantofi-sport-copii",
    ghete_copii: "/collections/ghete-copii",
    pantofi_copii: "/collections/pantofi-copii",

    // ACCESORII
    genti_rucsacuri: "/collections/genti-rucsacuri"
  };

  // =============================
  // UTILS (blindate)
  // =============================
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function escapeHtml(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function safePath(path) {
    // encodeURI păstrează / ? & = dar encodează diacriticele
    try { return encodeURI(path); } catch { return path; }
  }

  function withUTM(path, utm) {
    const p = safePath(path);
    try {
      const u = new URL(p, window.location.origin);
      Object.entries(utm).forEach(([k, v]) => u.searchParams.set(k, v));
      u.searchParams.set("tpq2", "1");
      u.searchParams.set("tpq2_v", TPQ2_VERSION);
      return u.pathname + "?" + u.searchParams.toString();
    } catch {
      const sep = p.includes("?") ? "&" : "?";
      const params = new URLSearchParams({ ...utm, tpq2: "1", tpq2_v: TPQ2_VERSION });
      return p + sep + params.toString();
    }
  }

  function normalizeCuloare(v) {
    if (!v) return "";
    const x = String(v).trim().toLowerCase();
    const map = {
      "negru": "Negru", "black": "Black",
      "alb": "Alb", "white": "White",
      "bej": "Bej", "beige": "Beige",
      "maro": "Maro", "brown": "Brown",
      "gri": "Gri", "gray": "Gray",
      "bleumarin": "Bleumarin", "navy": "Navy",
      "bordo": "Bordo", "burgundy": "Burgundy",
      "verde": "Verde", "green": "Green",
      "multicolor": "Multicolor"
    };
    return map[x] || (x.charAt(0).toUpperCase() + x.slice(1));
  }

  function aplicaFiltreShopify(url, profil) {
    // IMPORTANT: dacă tema ta nu suportă filtre pe URL, nu strică nimic.
    const culoare = profil.culoare && profil.culoare !== "oricare" ? normalizeCuloare(profil.culoare) : "";
    const marime = profil.marime && profil.marime !== "nu_stiu" ? String(profil.marime) : "";

    if (!culoare && !marime) return url;

    try {
      const u = new URL(url, window.location.origin);

      if (culoare) {
        [
          "filter.v.option.culoare",
          "filter.v.option.color",
          "filter.v.option.Culoare",
          "filter.v.option.Color"
        ].forEach(k => u.searchParams.append(k, culoare));
      }

      if (marime) {
        [
          "filter.v.option.mărime",
          "filter.v.option.marime",
          "filter.v.option.size",
          "filter.v.option.Mărime",
          "filter.v.option.Marime",
          "filter.v.option.Size"
        ].forEach(k => u.searchParams.append(k, marime));
      }

      return u.pathname + "?" + u.searchParams.toString();
    } catch {
      return url;
    }
  }

  function marimiLista(cine) {
    if (cine === "copii") {
      return ["nu_stiu","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35"];
    }
    return ["nu_stiu","35","36","37","38","39","40","41","42","43","44","45","46","47"];
  }

  // =============================
  // FLOW DINAMIC – BLINDAT
  // =============================
  function getFlow(p) {
    const flow = [];

    flow.push({
      key: "cine",
      q: "Pentru cine cauți?",
      note: "Te duc direct în zona corectă.",
      opts: [
        { v: "dama", t: "Damă", s: "Pantofi, ghete, sandale, accesorii" },
        { v: "barbati", t: "Bărbați", s: "Pantofi, ghete, sport" },
        { v: "copii", t: "Copii", s: "Casual + sport" }
      ]
    });

    flow.push({
      key: "tip",
      q: "Ce vrei acum?",
      note: "Asta decide ruta.",
      opts: [
        { v: "pantofi", t: "Pantofi", s: "Casual / sport / eleganți" },
        { v: "ghete", t: "Ghete", s: "Iarnă / tranziție" },
        { v: "sandale", t: "Sandale", s: "Vara / confort" },
        { v: "accesorii", t: "Genți / accesorii", s: "Genți, rucsacuri etc." }
      ]
    });

    if (p.tip === "accesorii") {
      flow.push({
        key: "culoare",
        q: "Ce culoare preferi?",
        note: "Dacă nu contează, alege „Nu țin neapărat”.",
        opts: culoareOpts()
      });

      flow.push({
        key: "buget",
        q: "Buget orientativ?",
        note: "Buget mic = îți pun și Reduceri în față.",
        opts: bugetOpts()
      });

      return flow;
    }

    // încălțăminte
    flow.push({
      key: "stil",
      q: "Ce stil vrei?",
      note: "Asta taie masiv opțiunile.",
      opts: [
        { v: "casual", t: "Casual", s: "De zi cu zi" },
        { v: "sport", t: "Sport", s: "Ușor + comod" },
        { v: "elegant", t: "Elegant", s: "Look curat / premium" }
      ]
    });

    flow.push({
      key: "folosire",
      q: "Cum îi folosești?",
      note: "Zilnic vs mers mult vs eveniment = recomandări diferite.",
      opts: [
        { v: "zilnic", t: "Zilnic", s: "Practic" },
        { v: "office", t: "Office", s: "Arată bine + suportabil" },
        { v: "mers_mult", t: "Mers mult", s: "Confort pe distanțe" },
        { v: "eveniment", t: "Eveniment", s: "Impact vizual" }
      ]
    });

    flow.push({
      key: "picior",
      q: "Cum e piciorul tău?",
      note: "Calapodul contează enorm.",
      opts: [
        { v: "normal", t: "Normal", s: "Standard" },
        { v: "lat", t: "Mai lat", s: "Vreau spațiu" },
        { v: "sensibil", t: "Sensibil", s: "Confort prioritar" }
      ]
    });

    flow.push({
      key: "mers",
      q: "Cât mergi pe jos într-o zi?",
      note: "Aici se decide confortul real.",
      opts: [
        { v: "putin", t: "Puțin", s: "1–3 km" },
        { v: "mediu", t: "Mediu", s: "3–7 km" },
        { v: "mult", t: "Mult", s: "7+ km" }
      ]
    });

    // sezon condițional
    if (p.tip === "ghete") {
      flow.push({
        key: "sezon",
        q: "Când le porți?",
        note: "La ghete nu te întreb de vară. Logic.",
        opts: [
          { v: "iarna", t: "Iarnă", s: "Frig + umezeală" },
          { v: "tranzitie", t: "Trecere", s: "Toamnă / primăvară" },
          { v: "tot_anul", t: "Tot anul", s: "Universal" }
        ]
      });
    } else if (p.tip === "sandale") {
      flow.push({
        key: "sezon",
        q: "Când le porți?",
        note: "La sandale nu te întreb de iarnă. Logic.",
        opts: [
          { v: "vara", t: "Vara", s: "Cald" },
          { v: "tot_anul", t: "Tot anul", s: "Concedii / interior" }
        ]
      });
    } else {
      // pantofi
      flow.push({
        key: "sezon",
        q: "În ce perioadă îi porți?",
        note: "Asta ajută la recomandarea corectă.",
        opts: [
          { v: "tranzitie", t: "Primăvară / toamnă", s: "Cel mai des" },
          { v: "vara", t: "Vara", s: "Mai aerisit" },
          { v: "tot_anul", t: "Tot anul", s: "Universal" }
        ]
      });
    }

    flow.push({
      key: "culoare",
      q: "Ce culoare preferi?",
      note: "Dacă nu contează, alege „Nu țin neapărat”.",
      opts: culoareOpts()
    });

    flow.push({
      key: "marime",
      q: "Ce mărime ai nevoie?",
      note: "Încerc să aplic filtrul de mărime în pagina de recomandări.",
      opts: marimiLista(p.cine).map(m => {
        if (m === "nu_stiu") return { v: "nu_stiu", t: "Nu știu / nu contează", s: "Arată-mi opțiunile" };
        return { v: m, t: m, s: "" };
      })
    });

    flow.push({
      key: "buget",
      q: "Buget orientativ?",
      note: "Buget mic = Reduceri în față.",
      opts: bugetOpts()
    });

    return flow;
  }

  function culoareOpts() {
    return [
      { v: "oricare", t: "Nu țin neapărat", s: "Orice culoare e ok" },
      { v: "Negru", t: "Negru", s: "Cel mai sigur" },
      { v: "Maro", t: "Maro", s: "Clasic" },
      { v: "Bej", t: "Bej", s: "Lumină / curat" },
      { v: "Alb", t: "Alb", s: "Fresh" },
      { v: "Gri", t: "Gri", s: "Neutru" },
      { v: "Bleumarin", t: "Bleumarin", s: "Elegant discret" },
      { v: "Bordo", t: "Bordo", s: "Cu personalitate" },
      { v: "Verde", t: "Verde", s: "Alt vibe" },
      { v: "Multicolor", t: "Multicolor", s: "Diferit" }
    ];
  }

  function bugetOpts() {
    return [
      { v: "mic", t: "Sub 250 lei", s: "Preț bun" },
      { v: "mediu", t: "250–400 lei", s: "Cel mai echilibrat" },
      { v: "mare", t: "Peste 400 lei", s: "Premium" }
    ];
  }

  function pickCollection(p) {
    if (p.tip === "accesorii") return COLLECTIONS.genti_rucsacuri;

    if (p.cine === "copii") {
      if (p.tip === "ghete") return COLLECTIONS.ghete_copii;
      if (p.tip === "pantofi") return (p.stil === "sport") ? COLLECTIONS.pantofi_sport_copii : COLLECTIONS.pantofi_casual_copii;
      return COLLECTIONS.pantofi_copii;
    }

    if (p.tip === "sandale") return p.cine === "dama" ? COLLECTIONS.sandale_dama : COLLECTIONS.sandale_barbati;

    if (p.tip === "ghete") {
      if (p.cine === "dama") {
        if (p.stil === "sport") return COLLECTIONS.ghete_sport_dama;
        if (p.stil === "elegant") return COLLECTIONS.ghete_elegante_dama;
        return COLLECTIONS.ghete_casual_dama;
      } else {
        if (p.stil === "sport") return COLLECTIONS.ghete_sport_barbati;
        if (p.stil === "elegant") return COLLECTIONS.ghete_elegante_barbati;
        return COLLECTIONS.ghete_casual_barbati;
      }
    }

    // pantofi
    if (p.cine === "dama") {
      if (p.stil === "sport") return COLLECTIONS.pantofi_sport_dama;
      if (p.stil === "elegant") return COLLECTIONS.pantofi_eleganti_dama;
      return COLLECTIONS.pantofi_casual_dama;
    } else {
      if (p.stil === "sport") return COLLECTIONS.pantofi_sport_barbati;
      if (p.stil === "elegant") return COLLECTIONS.pantofi_eleganti_barbati;
      return COLLECTIONS.pantofi_casual_barbati;
    }
  }

  // =============================
  // RENDER (aceeași abordare tpq2, fără conflicte)
  // =============================
  function render(container) {
    const accent = container.getAttribute("data-accent") || "#f26b00";
    const title = container.getAttribute("data-title") || "Quiz";
    const subtitle = container.getAttribute("data-subtitle") || "";

    const utm = {
      utm_source: container.getAttribute("data-utm-source") || "blog",
      utm_medium: container.getAttribute("data-utm-medium") || "quiz",
      utm_campaign: container.getAttribute("data-utm-campaign") || "tp_quiz"
    };

    const state = {
      idx: 0,
      profile: {
        cine: null,
        tip: null,
        stil: null,
        folosire: null,
        picior: null,
        mers: null,
        sezon: null,
        culoare: "oricare",
        marime: "nu_stiu",
        buget: null
      }
    };

    function flow() {
      return getFlow(state.profile);
    }

    container.innerHTML = `
      <style>
        .tpq2{--a:${accent};--a2:#ff8a2a;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial;max-width:980px;margin:24px auto}
        .tpq2 .card{background:linear-gradient(180deg,#0f1620,#0b1018);border:1px solid rgba(255,255,255,.10);border-radius:18px;box-shadow:0 14px 40px rgba(0,0,0,.25);overflow:hidden;color:rgba(255,255,255,.92)}
        .tpq2 .head{padding:22px}
        .tpq2 .badge{display:inline-flex;align-items:center;background:rgba(242,107,0,.14);border:1px solid rgba(242,107,0,.35);color:#ffb37a;padding:6px 10px;border-radius:999px;font-weight:900;font-size:12px}
        .tpq2 h2{margin:10px 0 6px;font-size:24px;line-height:1.15}
        .tpq2 p{margin:0;color:rgba(255,255,255,.70);font-size:14px;line-height:1.45}
        .tpq2 .prog{padding:0 22px 18px}
        .tpq2 .bar{height:10px;background:rgba(255,255,255,.08);border-radius:999px;overflow:hidden;border:1px solid rgba(255,255,255,.10)}
        .tpq2 .fill{height:100%;width:0%;background:linear-gradient(90deg,var(--a),var(--a2));transition:width .25s ease}
        .tpq2 .meta{display:flex;justify-content:space-between;align-items:center;margin-top:10px;color:rgba(255,255,255,.55);font-size:13px}
        .tpq2 .link{background:none;border:0;color:rgba(255,255,255,.70);text-decoration:underline;cursor:pointer;padding:6px 8px;border-radius:10px}
        .tpq2 .body{padding:0 22px 22px}
        .tpq2 .q{font-size:18px;font-weight:900;margin:10px 0 14px}
        .tpq2 .answers{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
        @media (max-width:720px){.tpq2 .answers{grid-template-columns:1fr}}
        .tpq2 .opt{display:flex;gap:10px;padding:12px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.04);border-radius:14px;cursor:pointer}
        .tpq2 .opt:hover{border-color:rgba(242,107,0,.35);background:rgba(255,255,255,.06)}
        .tpq2 .radio{width:18px;height:18px;border-radius:50%;border:2px solid rgba(255,255,255,.30);margin-top:2px;display:flex;align-items:center;justify-content:center;flex:none}
        .tpq2 .radio:after{content:"";width:10px;height:10px;border-radius:50%;background:transparent}
        .tpq2 .opt[aria-checked="true"]{border-color:rgba(242,107,0,.55);background:rgba(242,107,0,.10)}
        .tpq2 .opt[aria-checked="true"] .radio{border-color:rgba(242,107,0,.75)}
        .tpq2 .opt[aria-checked="true"] .radio:after{background:linear-gradient(90deg,var(--a),var(--a2))}
        .tpq2 .t{font-weight:900;font-size:14px;margin:0}
        .tpq2 .s{margin:2px 0 0;color:rgba(255,255,255,.70);font-size:13px;line-height:1.3}
        .tpq2 .nav{display:flex;justify-content:space-between;gap:10px;margin-top:16px}
        .tpq2 button.btn{border:0;border-radius:14px;padding:12px 14px;font-weight:900;cursor:pointer;background:rgba(255,255,255,.10);color:rgba(255,255,255,.92)}
        .tpq2 button.btn:disabled{opacity:.45;cursor:not-allowed}
        .tpq2 .primary{background:linear-gradient(90deg,var(--a),var(--a2));color:#140a00}
        .tpq2 .ghost{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12)}
        .tpq2 .note{margin-top:10px;min-height:18px;color:rgba(255,255,255,.55);font-size:12px}

        .tpq2 .results{display:none;padding:0 22px 22px}
        .tpq2 .cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:12px}
        @media (max-width:960px){.tpq2 .cards{grid-template-columns:1fr}}
        .tpq2 .r{border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.04);border-radius:18px;padding:14px}
        .tpq2 .r h4{margin:0 0 6px;font-size:16px}
        .tpq2 .mini{color:rgba(255,255,255,.70);font-size:13px;line-height:1.4}
        .tpq2 .actions{display:flex;gap:10px;margin-top:12px}
        .tpq2 .actions a{flex:1;text-align:center;text-decoration:none;display:inline-block}
        .tpq2 .error{margin-top:12px;padding:10px 12px;border-radius:12px;border:1px solid rgba(255,70,70,.35);background:rgba(255,70,70,.08);color:rgba(255,200,200,.95);font-size:13px}
      </style>

      <div class="tpq2">
        <div class="card">
          <div class="head">
            <div class="badge">Quiz Personalizat</div>
            <h2>${escapeHtml(title)}</h2>
            <p>${escapeHtml(subtitle)}</p>
          </div>

          <div class="prog">
            <div class="bar"><div class="fill" data-fill></div></div>
            <div class="meta">
              <span>Pas <span data-step>1</span>/<span data-total>1</span></span>
              <button class="link" type="button" data-reset>Resetează</button>
            </div>
          </div>

          <div class="body" data-body>
            <div class="q" data-q></div>
            <div class="answers" data-answers></div>

            <div class="nav">
              <button class="btn ghost" type="button" data-back disabled>Înapoi</button>
              <button class="btn primary" type="button" data-next disabled>Continuă</button>
            </div>

            <div class="note" data-note></div>
            <div class="error" data-error style="display:none;"></div>
          </div>

          <div class="results" data-results>
            <div class="q" style="margin-bottom:6px;">Recomandări pentru tine</div>
            <div class="mini">3 linkuri: colecția principală (cu filtre), reduceri, toate produsele.</div>
            <div class="cards" data-cards></div>

            <div class="nav" style="padding-top:14px;">
              <a class="btn primary" data-all href="${safePath(COLLECTIONS.all)}">Vezi toate produsele</a>
              <button class="btn ghost" type="button" data-restart>Refă testul</button>
            </div>
          </div>
        </div>
      </div>
    `;

    const elFill = container.querySelector("[data-fill]");
    const elStep = container.querySelector("[data-step]");
    const elTotal = container.querySelector("[data-total]");
    const elQ = container.querySelector("[data-q]");
    const elAnswers = container.querySelector("[data-answers]");
    const elNote = container.querySelector("[data-note]");
    const elError = container.querySelector("[data-error]");
    const elBack = container.querySelector("[data-back]");
    const elNext = container.querySelector("[data-next]");
    const elReset = container.querySelector("[data-reset]");
    const elBody = container.querySelector("[data-body]");
    const elResults = container.querySelector("[data-results]");
    const elCards = container.querySelector("[data-cards]");
    const elAll = container.querySelector("[data-all]");
    const elRestart = container.querySelector("[data-restart]");

    function setError(msg) {
      if (!msg) { elError.style.display = "none"; elError.textContent = ""; return; }
      elError.style.display = "";
      elError.textContent = msg;
    }

    function updateProgress() {
      const f = flow();
      elTotal.textContent = String(f.length);
      state.idx = clamp(state.idx, 0, f.length - 1);

      const pct = Math.round((state.idx / f.length) * 100);
      elFill.style.width = pct + "%";
      elStep.textContent = String(state.idx + 1);
    }

    function renderQ() {
      setError("");
      const f = flow();
      updateProgress();

      const q = f[state.idx];
      elQ.textContent = q.q;
      elNote.textContent = q.note || "";
      elAnswers.innerHTML = "";

      q.opts.forEach(opt => {
        const div = document.createElement("div");
        div.className = "opt";
        div.setAttribute("role", "radio");
        div.setAttribute("tabindex", "0");
        div.setAttribute("aria-checked", String(state.profile[q.key] === opt.v));

        div.innerHTML = `
          <div class="radio" aria-hidden="true"></div>
          <div>
            <p class="t">${escapeHtml(opt.t)}</p>
            <p class="s">${escapeHtml(opt.s || "")}</p>
          </div>
        `;

        const pick = () => {
          state.profile[q.key] = opt.v;

          // dacă schimbă "cine" sau "tip", curățăm răspunsurile care pot deveni invalide
          if (q.key === "cine") {
            state.profile.marime = "nu_stiu";
          }
          if (q.key === "tip") {
            // reset pentru compatibilitate: dacă devine accesorii, scoatem câmpuri de încălțăminte
            if (opt.v === "accesorii") {
              state.profile.stil = null;
              state.profile.folosire = null;
              state.profile.picior = null;
              state.profile.mers = null;
              state.profile.sezon = null;
              state.profile.marime = "nu_stiu";
            }
          }

          // UI select
          [...elAnswers.querySelectorAll(".opt")].forEach(x => x.setAttribute("aria-checked", "false"));
          div.setAttribute("aria-checked", "true");
          elNext.disabled = false;
          elNext.textContent = (state.idx === flow().length - 1) ? "Vezi recomandările" : "Continuă";
        };

        div.addEventListener("click", pick);
        div.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(); }
        });

        elAnswers.appendChild(div);
      });

      elBack.disabled = state.idx === 0;
      elNext.textContent = (state.idx === f.length - 1) ? "Vezi recomandările" : "Continuă";
      elNext.disabled = state.profile[q.key] == null;
    }

    function showResults() {
      setError("");

      try {
        // colecția principală
        const base = pickCollection(state.profile);

        // link principal (cu utm + filtre)
        let link1 = withUTM(base, utm);
        link1 = aplicaFiltreShopify(link1, state.profile);

        // reduceri + toate
        const link2 = withUTM(COLLECTIONS.reduceri, utm);
        const link3 = withUTM(COLLECTIONS.all, utm);

        const culoareTxt = state.profile.culoare === "oricare" ? "Nu țin neapărat" : normalizeCuloare(state.profile.culoare);
        const marimeTxt = state.profile.marime === "nu_stiu" ? "Nu știu / nu contează" : state.profile.marime;

        elCards.innerHTML = `
          <div class="r">
            <h4>1) Recomandarea principală</h4>
            <div class="mini">Colecția potrivită + filtre (culoare/mărime dacă se aplică).</div>
            <div class="mini" style="margin-top:8px;opacity:.9">
              Culoare: <b>${escapeHtml(culoareTxt)}</b> · Mărime: <b>${escapeHtml(marimeTxt)}</b>
            </div>
            <div class="actions">
              <a class="btn primary" href="${link1}">Deschide</a>
              <a class="btn ghost" href="${link2}">Reducerile</a>
            </div>
          </div>

          <div class="r">
            <h4>2) Reduceri (shortcut)</h4>
            <div class="mini">Dacă vrei preț bun rapid.</div>
            <div class="actions">
              <a class="btn primary" href="${link2}">Deschide</a>
              <a class="btn ghost" href="${link3}">Toate produsele</a>
            </div>
          </div>

          <div class="r">
            <h4>3) Toate produsele</h4>
            <div class="mini">Explorare completă.</div>
            <div class="actions">
              <a class="btn primary" href="${link3}">Deschide</a>
              <a class="btn ghost" href="${link2}">Reducerile</a>
            </div>
          </div>
        `;

        elAll.href = link3;

        elBody.style.display = "none";
        elResults.style.display = "";
        elFill.style.width = "100%";
        container.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch (e) {
        console.error("TPQ2 showResults error:", e);
        setError("A apărut o eroare tehnică la afișarea recomandărilor. Deschide consola (F12) și caută „TPQ2 showResults error”.");
      }
    }

    function resetAll() {
      state.idx = 0;
      state.profile = {
        cine: null, tip: null, stil: null, folosire: null, picior: null, mers: null, sezon: null,
        culoare: "oricare", marime: "nu_stiu", buget: null
      };
      elResults.style.display = "none";
      elBody.style.display = "";
      renderQ();
    }

    elBack.addEventListener("click", () => {
      if (state.idx > 0) { state.idx--; renderQ(); }
    });

    elNext.addEventListener("click", () => {
      setError("");

      const f = flow();
      const q = f[state.idx];
      if (!q || state.profile[q.key] == null) return;

      // dacă suntem pe ultimul pas -> rezultate
      if (state.idx >= f.length - 1) {
        showResults();
        return;
      }

      state.idx++;
      renderQ();
    });

    elReset.addEventListener("click", resetAll);
    elRestart.addEventListener("click", resetAll);

    renderQ();
  }

  function initAll() {
    const nodes = document.querySelectorAll('[data-tpq2="1"]:not([data-tpq2-mounted="1"])');
    nodes.forEach(node => {
      node.setAttribute("data-tpq2-mounted", "1");
      render(node);
    });
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);

  document.addEventListener("shopify:section:load", initAll);
})();


/* TotalPantofi Search Widget - v1.0 */
(function(){'use strict';var C={ms:200,pop:['skechers','adidas','nike','sport','sandale','cizme'],cur:'RON'},T=null;function f(c){return Math.round(c/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' RON';}function h(t,q){if(!q||!t)return t||'';return t.replace(new RegExp('('+q.replace(/[.*+?^${}()|[\\]\\]/g,'\\$&')+')','gi'),'<b>$1</b>');}function css(){if(document.getElementById('tp-sc'))return;var s=document.createElement('style');s.id='tp-sc';s.textContent='.tp-sw{position:relative}.tp-sd{position:absolute;top:calc(100% + 4px);left:0;right:0;background:#fff;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 8px 28px rgba(0,0,0,.13);z-index:99999;display:none;max-height:460px;overflow-y:auto;font-size:14px}.tp-sd.on{display:block}.tp-sh{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#aaa;padding:8px 14px 3px}.tp-sa,.tp-sq{display:flex;align-items:center;gap:9px;padding:7px 14px;text-decoration:none;color:#222;cursor:pointer;transition:background .1s}.tp-sa:hover,.tp-sq:hover{background:#f5f5f5}.tp-si{width:42px;height:42px;object-fit:cover;border-radius:4px;flex-shrink:0;background:#f0f0f0}.tp-sn{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500}.tp-sv{font-size:12px;color:#999}.tp-sp{font-weight:600;flex-shrink:0}.tp-sdiv{height:1px;background:#eee;margin:3px 0}.tp-stags{padding:5px 10px 9px}.tp-stag{display:inline-block;padding:4px 11px;margin:3px;background:#f5f5f5;border:1px solid #e0e0e0;border-radius:20px;font-size:13px;text-decoration:none;color:#333;cursor:pointer;transition:all .13s}.tp-stag:hover{background:#111;color:#fff;border-color:#111}.tp-sf{padding:8px 14px;text-align:center;font-size:13px;color:#666;border-top:1px solid #eee;cursor:pointer}.tp-sf:hover{background:#f5f5f5}.tp-se{padding:16px 14px;text-align:center;color:#aaa}';document.head.appendChild(s);}function pop(){return '<div class="tp-sh">Cautari populare</div><div class="tp-stags">'+C.pop.map(function(t){return '<a href="/search?q='+encodeURIComponent(t)+'" class="tp-stag">'+t+'</a>';}).join('')+'</div>';}function bld(data,q){if(!data)return '<div class="tp-se">Se cauta...</div>';var P=(data.resources&&data.resources.results&&data.resources.results.products)||[],Q=(data.resources&&data.resources.results&&data.resources.results.queries)||[];if(!P.length&&!Q.length)return '<div class="tp-se">Niciun rezultat pentru <b>'+q+'</b></div>';var html='';if(Q.length){html+='<div class="tp-sh">Sugestii</div>';Q.slice(0,4).forEach(function(i){html+='<a class="tp-sq" href="'+i.url+'">'+i.text+'</a>';});}if(P.length){if(Q.length)html+='<div class="tp-sdiv"></div>';html+='<div class="tp-sh">Produse ('+P.length+')</div>';P.forEach(function(p){var img=(p.featured_image&&p.featured_image.url)?'<img class="tp-si" src="'+p.featured_image.url+'&width=84" alt="" loading="lazy">':'<div class="tp-si"></div>';html+='<a class="tp-sa" href="'+p.url+'">'+img+'<span class="tp-sn">'+h(p.title,q)+(p.vendor?'<div class="tp-sv">'+p.vendor+'</div>':'')+' </span>'+(p.price?'<b class="tp-sp">'+f(p.price)+'</b>':'')+' </a>';});}if(q)html+='<div class="tp-sf" onclick="location.href=\'/ search?q='+encodeURIComponent(q)+'\'">Vezi toate &rarr;</div>';return html;}function srch(drop,q){drop.innerHTML='<div class="tp-se">Se cauta...</div>';drop.classList.add('on');fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last').then(function(r){return r.ok?r.json():null;}).then(function(d){drop.innerHTML=bld(d,q);}).catch(function(){drop.innerHTML='<div class="tp-se">Eroare</div>';});}function att(inp){var par=inp.parentNode,sw=document.createElement('span');sw.className='tp-sw';sw.style.cssText='display:block;position:relative';par.insertBefore(sw,inp);sw.appendChild(inp);var drop=document.createElement('div');drop.className='tp-sd';sw.appendChild(drop);inp.addEventListener('focus',function(){var q=inp.value.trim();if(q)srch(drop,q);else{drop.innerHTML=pop();drop.classList.add('on');}});inp.addEventListener('input',function(){clearTimeout(T);T=setTimeout(function(){var q=inp.value.trim();if(q)srch(drop,q);else{drop.innerHTML=pop();drop.classList.add('on');}},C.ms);});inp.addEventListener('keydown',function(e){if(e.key==='Escape')drop.classList.remove('on');if(e.key==='Enter'){drop.classList.remove('on');if(inp.value.trim())location.href='/search?q='+encodeURIComponent(inp.value.trim())+'&options[prefix]=last';}});document.addEventListener('click',function(e){if(!sw.contains(e.target))drop.classList.remove('on');});}function init(){css();var done=new Set();document.querySelectorAll('input[name="q"],input[type="search"],.search__input').forEach(function(el){if(done.has(el)||el.closest('predictive-search')||el.closest('.tp-sd'))return;done.add(el);att(el);});}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init);})();